<script setup>
import Card from "@/components/Card/index.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import Contacts from "@/views/chat/Contacts.vue";
import Icon from "@/components/Icon/index.vue";
import {useChatStore} from "@/stores/chat.js";
import {useUserStore} from "@/stores/user.js";
import {useThemeSettingsStore} from "@/stores/themeSettings";
import {ref} from "vue";

const userStore = useUserStore()
const chatStore = useChatStore()
const themeSettingsStore = useThemeSettingsStore()

const toggleMsidebar = () => {
  themeSettingsStore.toggleMsidebar()
};

function pendingReply() {
  chatStore.filters.pendingReply = !chatStore.filters.pendingReply;
}

let searchTimeoutId = null
const keyword = ref('')
const isSearching = ref(false)

function onInput(e) {
  //console.log(e.target.value)
  // Cancel any existing search timeout
  clearTimeout(searchTimeoutId)
  // Start a new search timeout
  searchTimeoutId = setTimeout(() => {
    search_by_keyword(e.target.value)
  }, 1000)
}

async function search_by_keyword(query) {
  if (query && query.length > 2) {
    if (query !== keyword.value) {
      isSearching.value = true
      keyword.value = query
      chatStore.searchContactError = ''
      const res = await chatStore.action_searchContact({keyword: query})
      if (res.result === true) {
        //console.log('searched')
      } else {
        //console.log(res)
        chatStore.searchContactError = res
      }
      //We hide the loading with a 1 second delay because we want the search that is performed every two seconds to finish and then hide the loading.
      setTimeout(() => {
        isSearching.value = false;
      }, 1000)
    } else {
      keyword.value = query
    }
  } else {
    keyword.value = query
  }
}

const resetSearch = () => {
  chatStore.searchQuery = ''
  chatStore.searchContactError = ''
}
</script>

<template>
  <div class="absolute left-0 top-0 w-[280px] z-[99] h-full lg:hidden p-2">
    <Card
        bodyClass="relative p-0 h-full overflow-hidden"
        class-name="h-full rounded-tl-md rounded-bl-md rounded-tr-none rounded-br-none"
    >

        <div class="flex flex-col h-full divide-y divide-slate-100 dark:divide-slate-700">
          <div class="flex gap-3 items-center p-2">
            <div class="flex-1">
              <span class="text-slate-800 dark:text-slate-300 text-sm font-medium flex flex-row gap-2 items-center">
                <span @click="toggleMsidebar"
                      class="h-6 w-6 bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path
                      fill="currentColor"
                      d="M1.014 7.382a.5.5 0 0 0-.013.152c-.014.4.133.806.439 1.112l2.12 2.122a.5.5 0 1 0 .708-.708L2.208 8H14.5a.5.5 0 0 0 0-1H2.379l1.889-1.89a.5.5 0 0 0-.707-.706L1.44 6.524a1.5 1.5 0 0 0-.426.858M14.5 3h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1m0 8h-7a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1"/>
                  </svg>
                  <!--                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                      <path fill="none"
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                            d="M12 6.826A.913.913 0 1 0 12 5a.913.913 0 0 0 0 1.826m6.088 0a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826m-12.176 0a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826M12 12.913a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826m6.088 0a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826m-12.176 0a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826M12 19a.913.913 0 1 0 0-1.826A.913.913 0 0 0 12 19m6.088 0a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826M5.912 19a.913.913 0 1 0 0-1.826a.913.913 0 0 0 0 1.826"/>
                                    </svg>-->
                </span>
                <span>{{ userStore.getName }}</span>
              </span>
            </div>
            <div class="flex-none flex flex-row gap-1">
              <div
                  @click="pendingReply"
                  class="h-6 w-6 bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center rounded-full cursor-pointer"
                  :class="{'border border-blue-500 shadow-[0_0_20px_5px_rgba(59,130,246,0.6)]': chatStore.get_is_pending_reply_active}"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                  <g fill="currentColor" :class="{'fill-slate-200': chatStore.get_is_pending_reply_active}"
                     fill-rule="evenodd" clip-rule="evenodd">
                    <path
                        d="M5.604 5.45a6.44 6.44 0 0 0-1.883 5.278a.5.5 0 0 1-.994.105a7.44 7.44 0 0 1 2.175-6.096c2.937-2.897 7.675-2.85 10.582.098s2.888 7.685-.05 10.582a7.43 7.43 0 0 1-5.097 2.142a7.5 7.5 0 0 1-2.14-.271a.5.5 0 0 1 .266-.964a6.5 6.5 0 0 0 1.856.235a6.42 6.42 0 0 0 4.413-1.854c2.541-2.506 2.562-6.61.04-9.168s-6.627-2.594-9.168-.088"/>
                    <path
                        d="M3.594 11.363a.5.5 0 0 1-.706.04l-1.72-1.53a.5.5 0 1 1 .664-.746l1.72 1.53a.5.5 0 0 1 .042.706"/>
                    <path
                        d="M2.82 11.3a.5.5 0 0 0 .7.1l2-1.5a.5.5 0 1 0-.6-.8l-2 1.5a.5.5 0 0 0-.1.7M10 6.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5"/>
                    <path d="M13.5 10.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5"/>
                  </g>
                </svg>
              </div>
              <div
                  @click="chatStore.toggleFilterDrawer()"
                  class="h-6 w-6 bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full cursor-pointer"
                  :class="{'border border-blue-500 shadow-[0_0_20px_5px_rgba(59,130,246,0.6)]': chatStore.get_is_filter_active}"
              >
<!--                <Icon icon="lets-icons:filter-big" class="text-sm"
                      :class="{'text-white': chatStore.get_is_filter_active}"/>-->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" class="text-sm"
                     :class="{'text-slate-300': chatStore.get_is_filter_active}">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
                    <path d="M10 8h10M4 16h10"/>
                    <circle cx="7" cy="8" r="3" transform="rotate(90 7 8)"/>
                    <circle cx="17" cy="16" r="3" transform="rotate(90 17 16)"/>
                  </g>
                </svg>
              </div>
              <Tooltip placement="top" arrow>
                <template #button>
                  <div
                      @click="chatStore.toggleMobileSidebar()"
                      class="h-6 w-6 bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full cursor-pointer"
                  >
                    <Icon icon="heroicons-outline:x" class="text-sm"/>
                  </div>
                </template>
                <span>close</span>
              </Tooltip>
            </div>
          </div>
          <div class="p-2">
            <div
                class="search rounded flex items-center space-x-3 rtl:space-x-reverse"
            >
              <div class="flex-none text-base text-slate-900 dark:text-slate-400">
                <Icon icon="bytesize:search"/>
              </div>
              <input
                  @input="onInput"
                  v-model="chatStore.searchQuery"
                  placeholder="Search..."
                  class="w-full flex-1 block bg-transparent placeholder:font-normal placeholder:text-slate-400 py-2 focus:ring-0 focus:outline-none dark:text-slate-200 dark:placeholder:text-slate-400"
              />
              <Icon v-if="isSearching" icon="eos-icons:bubble-loading" class="text-white" height="24"/>
              <div v-if="chatStore.searchQuery"
                   class="flex-none text-base text-slate-900 dark:text-slate-400 cursor-pointer"
                   @click="resetSearch">
                <Icon icon="iconamoon:close-bold"/>
              </div>
            </div>
          </div>
          <div class="flex-1 overflow-y-auto custom-scrollbar">
            <Contacts/>
          </div>
        </div>

    </Card>
  </div>
</template>

<style scoped lang="scss">

</style>
